// Shared Source dropdown options for the deal source field.
// Used by: NewDealModal (Start from scratch) and FieldMapping (Extraction review).
// CW6.2.7: one shared list so both screens always match.
export const DEAL_SOURCE_OPTIONS = [
  { value: "inbound", label: "Inbound" },
  { value: "referral", label: "Referral" },
  { value: "outbound", label: "Outbound" },
  { value: "event", label: "Event" },
  { value: "email", label: "Email Ingestion" },
];

// Case-insensitive match of any value or label to a canonical option key.
// Returns the matching option.value or "" if nothing matches.
export function matchSourceOption(raw) {
  if (!raw) return "";
  const s = String(raw).trim().toLowerCase();
  if (!s) return "";
  for (const o of DEAL_SOURCE_OPTIONS) {
    if (o.value.toLowerCase() === s) return o.value;
    if (o.label.toLowerCase() === s) return o.value;
  }
  // common synonyms
  if (s === "email ingestion" || s === "email_ingestion") return "email";
  return "";
}
